// extracted by mini-css-extract-plugin
export default {"fs":"_489892cc68 e6c94ce522"};